import React from "react";
import CardModel from "../components/CardModel";

const SelectModel = () => {
  return (
    <div className="p-4">
      <CardModel listStyle />
    </div>
  );
};

export default SelectModel;
